import { render, staticRenderFns } from "./GitHubProfile.vue?vue&type=template&id=05c7e9cc&scoped=true&"
import script from "./GitHubProfile.vue?vue&type=script&lang=js&"
export * from "./GitHubProfile.vue?vue&type=script&lang=js&"
import style0 from "./GitHubProfile.vue?vue&type=style&index=0&id=05c7e9cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c7e9cc",
  null
  
)

export default component.exports